import React from 'react';
import { getExternalAppIconDataUri, getExternalAppIconClass, isKpiMarketPlaceExternalApp, getKpiExternalAppDisplayNameById} from '../utils/kpi-market-place-util';
import { krdetailConstants as Constants } from '../constants/krdetails.constants';

function getExternalDataSourceIconClassNames (extAppId) {
  if (!extAppId) {
    return { icon: 'icon-data-integration-14px', description: 'External Source' };
  }

  switch (extAppId) {
    case Constants.JIRA_ID:
      return { icon: 'icon-Jira-logo-14px', description: 'JIRA' };
    case Constants.ASANA_ID:
      return { icon: 'icon-asana_14px', description: 'Asana' };
    case Constants.MS_PLANNER_ID:
      return { icon: 'icon-ms_planner_14px', description: 'Microsoft Planner' };
    case Constants.AZURE_CLOUD_ID:
      return { icon: 'icon-Azure-DevOps_14px', description: 'Azure DevOps' };
    case Constants.SALESFORCE_APP_ID:
      return { icon: 'icon-salesforce-logo-14px', description: 'Salesforce' };
    case Constants.IFRAME_HOSTED_EXT_SOURCE_ID:
      return { icon: 'icon-Microsoft-KR-Studio_14px', description: 'Microsoft KR Studio' };
    case Constants.RALLY_APP_ID:
      return { icon: 'icon-rally-logo-14px', description: 'Rally' };
    case Constants.POWERBI_APP_ID:
      return { icon: 'icon-powerbi-logo-14px', description: 'Power BI' };
    case Constants.SMARTSHEET_ID:
      return { icon: 'icon-smartsheet-logo-14px', description: 'Smartsheet' }
    case Constants.TABLEAU_ID:
      return { icon: 'icon-tableau-logo-14px', description: 'Tableau'}
    case Constants.EXCEL_ID:
      return { icon: 'icon-excel-logo-14px', description: 'Excel'}
    case Constants.SNOWFLAKE_ID:
      return { icon: 'icon-snowflake-logo-14px', description: 'Snowflake'}
    case Constants.GSHEET_ID:
      return { icon: 'icon-gsheet-logo-14px', description: 'Gsheet'}
    case Constants.TRELLO_ID:
      return { icon: 'icon-trello-logo-14px', description: 'Trello'}
    case Constants.GREENHOUSE_ID:
      return { icon: 'icon-greenhouse-logo-14px', description: 'Greenhouse'}
    case Constants.JIRA_KPI_ID:
      return { icon: 'icon-jira-kpi-logo-14px', description: 'Jira'}
    case Constants.GITLAB_ID:
      return { icon: 'icon-gitlab-logo-14px', description: 'Gitlab'}
    case Constants.ASANA_KPI_ID:
      return { icon: 'icon-asana-kpi-logo-14px', description: 'Asana'}
    case Constants.HUBSPOT_ID:
      return { icon: 'icon-hubspot-logo-14px', description: 'HubSpot'}
    case Constants.MONDAY_KPI_ID:
      return { icon: 'icon-monday-logo-14px', description: 'Monday'}
    case Constants.AZURE_DEVOPS_KPI_ID:
      return { icon: 'icon-Azure-DevOps_14px', description: 'Azure DevOps'}
    case Constants.MS_PLANNER_KPI_ID:
      return { icon: 'icon-ms_planner_14px', description: 'MS Planner'}
    case Constants.WRIKE_KPI_ID:
      return { icon: 'icon-wrike-logo-14px', description: 'Wrike'}
    default:
      if (isKpiMarketPlaceExternalApp(extAppId)) {
        return {
          description: getKpiExternalAppDisplayNameById(extAppId),
          icon: getExternalAppIconClass(extAppId),
          dataUri: getExternalAppIconDataUri(extAppId),
        }
      }
      return {};
  }
}

export function getDataSourceInfo (kr, isOwnerTheDataSource) {
  const source = parseInt(kr.source, 10);
  const type = parseInt(kr.type, 10);

  if (type === Constants.TYPE_CASCADE) {
    return { icon: 'icon-cascade-14px', description: 'Cascaded Key Result' };
  }

  if ((source === Constants.SOURCE_PERSON || source === Constants.SOURCE_MIT_PERSON)
    && !isOwnerTheDataSource
  ) {
    return { icon: 'icon-outline-people-14px-2', description: 'Individual' };
  }

  if (source === Constants.SOURCE_EXT_SOURCES && kr.extAppId) {
    return getExternalDataSourceIconClassNames(parseInt(kr.extAppId, 10));
  }

  switch (source) {
    case Constants.SOURCE_WORKSTREAM:
      return { icon: 'icon-outline-waves-14px', description: 'Workstream' };
    case Constants.SOURCE_METRICS:
      return { icon: 'icon-KR-14px', description: 'Rolled up Key Result' };
    case Constants.SOURCE_SURVEY:
      return { icon: 'icon-outline-people-14px-1', description: 'Survey' };
    case Constants.SOURCE_OTHER_GOALS:
      return { icon: 'icon-outline-bar_chart-14px', description: 'Rolled up OKR' };
    case Constants.SOURCE_DATA_STREAMS:
    case Constants.SOURCE_MIT_DATA_STREAMS:
    case Constants.SOURCE_EXT_SOURCES:
      return { icon: 'icon-data-integration-14px', description: 'External Source' };
    case Constants.SOURCE_MIRROR_KR:
      return { icon: 'icon-outline-link-14px', description: 'Mirrored KR' };
    default:
      return {};
  }
}

const KrDataSourceIcon = ({
  kr: {
    source,
    type,
    ext_app_id: extAppId,
  },
  isOwnerTheDataSource,
  className,
  style={}
}) => {
  const { icon, description, dataUri} = getDataSourceInfo(
    { source, type, extAppId },
    isOwnerTheDataSource
  );
  if (!icon && !dataUri) {
    return null;
  }
  if (!icon && dataUri) {
    return (<span className={`${className}`}><img src={dataUri} style={{ width: "14px", ...style}}/></span>);
  }
  return (
    <span className={`${className} icon ${icon}`} style={style}>
      <span className="screen-reader-only">{`Data from ${description}`}</span>
    </span>
  );
}

export default KrDataSourceIcon;
